export enum ShowReport {
  All = 'all',
  Total = 'total',
  Average = 'average',
}
